class AuthDropdown extends window.BAO.CustomElement() {
  static get requiredEls () {
    return ['recover-tab', 'recover-link', 'cancel-link']
  }

  setupListeners () {
    super.setupListeners()

    this.setSubmitState = this.setSubmitState.bind(this)
    this.onRecoverLinkClick = this.onRecoverLinkClick.bind(this)
    this.onCancelLinkClick = this.onCancelLinkClick.bind(this)

    this.listeners.add(this, 'input', this.setSubmitState)
    this.listeners.add(
      this.els['recover-link'].element,
      'click',
      this.onRecoverLinkClick,
    )
    this.listeners.add(
      this.els['cancel-link'].element,
      'click',
      this.onCancelLinkClick,
    )
  }

  onRecoverLinkClick () {
    this.els['recover-tab'].element.click()
  }

  onCancelLinkClick () {
    const firstTab = window.BAO.Utils.getElement('bao-tab', { context: this })
    if (!firstTab) return

    firstTab.click()
  }

  setSubmitState (e) {
    const form = e.target.closest('form')
    if (!form) return

    const submit = window.BAO.Utils.getElement('[type="submit"]', {
      context: form,
    })
    if (!submit) return

    submit.disabled = !form.checkValidity()
  }
}

if (!customElements.get('auth-dropdown')) {
  customElements.define('auth-dropdown', AuthDropdown)
}
